import React, { FC } from "react";
import { IonIcon, IonText } from "@ionic/react";
import { addOutline, removeOutline } from "ionicons/icons";
import "./ScoreCounter.css";

interface ScoreCounterProps {
    value: number;
    onChange: (newValue: number) => void;
    testId?: string;
    min?: number;
}

export const ScoreCounter: FC<ScoreCounterProps> = ({
    value,
    onChange,
    testId,
    min = 0,
}) => {
    const handleDecrement = () => {
        if (value > min) {
            onChange(value - 1);
        }
    };

    const handleIncrement = () => {
        onChange(value + 1);
    };

    const isDecrementDisabled = value <= min;

    return (
        <div className="score-counter-container">
            <div
                className={`score-counter-btn ${isDecrementDisabled ? "disabled" : ""}`}
                onClick={handleDecrement}
                data-testid={testId ? `${testId}-decrement` : undefined}
            >
                <IonIcon icon={removeOutline} />
            </div>
            <IonText className="score-counter-value" data-testid={testId}>
                {value}
            </IonText>
            <div
                className="score-counter-btn"
                onClick={handleIncrement}
                data-testid={testId ? `${testId}-increment` : undefined}
            >
                <IonIcon icon={addOutline} />
            </div>
        </div>
    );
};
